import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { ExternalLink } from "@pages/AdminDashboard/ui/DataTable/cells";
import { Case } from "@types-runway/case";

const { color, typeScale } = adminTokens;
const [, spaceSm] = adminTokens.spacing;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spaceSm}px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Product = styled.span`
  font-family: ${typeScale.labelValue.fontFamily};
`;

const Pending = styled.span`
  color: ${color.inkSoft};
`;

const medicationUrl = (medicationId: string) =>
  `https://admin.mdintegrations.com/resources/partner-medications/${medicationId}`;

interface CaseConditionsPanelProps {
  caseRecord: Case;
}

// CVIEW-R10: the Case's conditions with the medication suggested for each, in a panel under its
// row. Patient health data stays out of analytics capture.
export const CaseConditionsPanel = ({ caseRecord }: CaseConditionsPanelProps) => {
  const conditions = caseRecord.conditions ?? [];

  return (
    <div data-testid={`case-conditions-${caseRecord.id}`} className="ph-no-capture">
      {conditions.length === 0 && <p>No conditions on this case.</p>}
      <List>
        {conditions.map(({ product, suggestedMedication }) => (
          <li key={product.name}>
            <Product>{product.name}</Product>
            {": "}
            {suggestedMedication?.id ? (
              <ExternalLink href={medicationUrl(suggestedMedication.id)}>
                {suggestedMedication.name || suggestedMedication.id}
              </ExternalLink>
            ) : (
              <Pending>Pending</Pending>
            )}
          </li>
        ))}
      </List>
    </div>
  );
};
